// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__rm+SL","spin":"Spinner_spin__aT7f8"};